import React, { useLayoutEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { MainColors } from '../../../constants/Colors';
import MainButton from '../../../components/Buttons/MainButton';
import HeaderButton from '../../../components/Buttons/HeaderButton';
import BallotsList from '../../../components/BallotsList';

const AdminBallotListScreen = ({ navigation }) => {

    const onCreateBallotPressedHandler = () => {
        navigation.navigate('AdminBallotForm', { ballotId: undefined });
    }

    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: 'Admin Ballots',
            headerRight: () => (
                <HeaderButton
                    onPress={onCreateBallotPressedHandler}
                    // disabled={saveButtonDisabled}
                    accessibilityLabel="Create"
                    accessibilityHint="Press this button to create a new ballot"
                    buttonText="Create"
                />
            )
        });
    }, [navigation]);

    const CreateButtonComponent = (
        <MainButton
            onPress={onCreateBallotPressedHandler}
            text={'Create New Ballot'}
            accessibilityLabel="Create new ballot"
            accessibilityHint="Press this button to create a new ballot"
        />
    )

    return (
        <View style={styles.screen}>
            <BallotsList
                createMode={true}
                showDeleted={true}
                filterStatus=""
                cardPressDisabled={true}
                editButtonShown={true}
                onEditButtonPress={(id) => navigation.push('AdminBallotForm', {
                    ballotId: id
                })}
                noBallotsMessageLineOne="Huh? No ballots?! Unacceptable."
                noBallotsMessageLineTwo="Let’s create some! 🤓"
                ListFooterComponent={CreateButtonComponent}
                onEmptyBallotListCreateBtnPress={onCreateBallotPressedHandler}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        backgroundColor: MainColors.grayBackground
    }
});

export default AdminBallotListScreen;